import React from 'react'
import { Refinement } from 'lib/Refinement/types'

import CustomHierarchicalMenu from 'components/Filters/CategoryFilter/CustomHierarchicalMenu'

const prettify = (string: string) =>
  string.replace(/ > /g, '_').replace(/ /g, '-')

const uglify = (string: string) =>
  string.replace(/-/g, ' ').replace(/_/g, ' > ')

export const categoryRefinement: Refinement = {
  getQueryParamValue: ({ hierarchicalMenu }) =>
    hierarchicalMenu?.['publicFilters.categories.lvl0'] && {
      category: prettify(hierarchicalMenu['publicFilters.categories.lvl0']),
    },
  getStateValue: ({ category }) =>
    category && {
      hierarchicalMenu: {
        'publicFilters.categories.lvl0': uglify(category as string),
      },
    },
}

const LIMIT_PER_LEVEL = 12
const ATTRIBUTES = [
  'publicFilters.categories.lvl0',
  'publicFilters.categories.lvl1',
  'publicFilters.categories.lvl2',
]

const CategoryFilter = (): JSX.Element => (
  <CustomHierarchicalMenu attributes={ATTRIBUTES} limit={LIMIT_PER_LEVEL} />
)

export default CategoryFilter
